import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Localbushireinpune() {


const cardData = {
keyword: "Local Bus Hire In Pune",
headingDescription: "Ruturaj Enterprises offers Local Bus Hire In Pune for convenient city travel, sightseeing, family outings, weddings, school trips, corporate requirements, picnics, events, and group transportation. Different bus options can be arranged according to passenger strength, journey duration, comfort preferences, and local travel plans, including AC and luxury options. Whether the requirement is for a few hours, a full-day city tour, multiple pickup points, or organized group movement across Pune, the service can be planned around your schedule and destination requirements.",
topPlaces: [
{
title: "Shaniwar Wada",
description: "Shaniwar Wada is one of Pune's most recognized historical landmarks and a popular stop for city sightseeing groups. A local bus makes it easier for families, students, tourists, and larger groups to travel together while visiting the historic area and nearby attractions."
},
{
title: "Aga Khan Palace",
description: "Aga Khan Palace is an important historical attraction and a frequent destination for visitors exploring Pune. Group bus transportation provides convenient movement for organized sightseeing programs, school excursions, family trips, and tourist groups visiting the landmark."
},
{
title: "Sinhagad Fort",
description: "Sinhagad Fort attracts families, friends, school groups, and travelers looking for a day outing near Pune. A hired local bus can accommodate groups traveling together and provide practical transportation for a planned sightseeing or picnic itinerary."
},
{
title: "Saras Baug",
description: "Saras Baug is a popular recreational destination within Pune and can be included in local family and sightseeing programs. Group transportation helps families, senior citizens, school groups, and tourists move comfortably between multiple city attractions."
},
{
title: "Pashan Lake",
description: "Pashan Lake offers a peaceful local destination for short outings and nature-focused group visits. A local bus can be useful for organizations, families, and groups planning a convenient city excursion with coordinated pickup and return arrangements."
},
{
title: "Khadakwasla Dam",
description: "Khadakwasla Dam is a well-known destination for short trips and recreational outings around Pune. Local bus hire allows larger groups to travel together and can be arranged for family excursions, college groups, office outings, and picnic plans."
},
{
title: "Pataleshwar Cave Temple",
description: "Pataleshwar Cave Temple is located within Pune and is suitable for historical, cultural, and religious sightseeing programs. A dedicated local bus can help groups cover this attraction along with other city destinations according to a planned itinerary."
},
{
title: "Rajiv Gandhi Zoological Park",
description: "Rajiv Gandhi Zoological Park is a popular destination for families and educational group visits. Schools, families, and organized groups can use local buses for comfortable transportation while coordinating multiple passengers and convenient pickup points."
},
{
title: "Dagdusheth Halwai Ganpati Temple",
description: "Dagdusheth Halwai Ganpati Temple is an important religious destination in central Pune and is visited by devotees throughout the year. Local bus transportation can help religious groups and families travel together while visiting the temple and other nearby attractions."
},
{
title: "Katraj",
description: "Katraj is an important southern part of Pune with residential areas, recreational destinations, and convenient road connectivity. Local buses can support group transportation for picnics, family outings, school programs, events, and city travel starting from or passing through the area."
}
],
services: [
{
name: "Local Bus Rental Pune",
description: "Local Bus Rental Pune is suitable for city travel, sightseeing, family outings, events, school programs, and short-duration group transportation. Ruturaj Enterprises can arrange a suitable bus according to passenger count, travel duration, pickup locations, and planned destinations within Pune."
},
{
name: "Local Bus Hire Pune",
description: "Local Bus Hire Pune provides a convenient transportation option when several passengers need to travel together within the city. The bus can be planned for hourly requirements, half-day programs, full-day trips, multiple stops, or scheduled group movements."
},
{
name: "Local Bus Booking Pune",
description: "Local Bus Booking Pune allows families, organizations, schools, and event groups to plan their transportation before the journey. Bus requirements can be discussed according to group size, preferred vehicle type, pickup point, destination list, and expected travel schedule."
},
{
name: "Bus on Rent for Local Travel Pune",
description: "Bus on Rent for Local Travel Pune is useful for groups visiting multiple destinations around the city or attending planned activities. A dedicated bus keeps the group together and can reduce the need to coordinate several separate vehicles during the journey."
},
{
name: "Local AC Bus Rental Pune",
description: "Local AC Bus Rental Pune offers a more comfortable option for city travel, especially during warm weather or longer sightseeing schedules. AC buses are suitable for families, corporate teams, tourists, wedding groups, and other passengers looking for a comfortable group journey."
},
{
name: "Local Luxury Bus Hire Pune",
description: "Local Luxury Bus Hire Pune is designed for premium group transportation during weddings, corporate programs, special events, family functions, and tourist journeys. Spacious seating and enhanced comfort make luxury buses suitable when the travel experience is an important part of the occasion."
},
{
name: "Local Bus Service Pune",
description: "Local Bus Service Pune supports a wide range of city transportation needs, from sightseeing and family travel to school excursions and corporate events. Routes can be organized according to the number of passengers, pickup locations, destinations, and travel timings."
},
{
name: "City Bus Rental Pune",
description: "City Bus Rental Pune is convenient for groups requiring transportation across different areas of Pune during the same day. A dedicated bus can follow an itinerary covering attractions, event venues, hotels, offices, residential areas, and other scheduled stops."
},
{
name: "Pune City Tour Bus Rental",
description: "Pune City Tour Bus Rental provides group transportation for organized city sightseeing programs covering historical, cultural, religious, and recreational attractions. The itinerary can include multiple stops while keeping the entire group together throughout the tour."
},
{
name: "Local Sightseeing Bus Pune",
description: "Local Sightseeing Bus Pune is suitable for tourists, families, educational groups, and visitors who want to explore several Pune attractions in one journey. Dedicated transportation allows the group to move between sightseeing locations without repeatedly arranging separate vehicles."
},
{
name: "Local Group Travel Bus Pune",
description: "Local Group Travel Bus Pune provides a practical solution for friends, relatives, organizations, and large groups traveling together within Pune. Vehicle selection can be matched with passenger strength so the journey remains organized and convenient."
},
{
name: "Local Family Trip Bus Pune",
description: "Local Family Trip Bus Pune is suitable for family gatherings, reunions, celebrations, temple visits, sightseeing, and recreational outings. Families can travel together from a common pickup point or use multiple planned pickup locations before beginning the local journey."
},
{
name: "Local Wedding Bus Hire Pune",
description: "Local Wedding Bus Hire Pune helps transport relatives, guests, and wedding groups between homes, hotels, wedding halls, banquet venues, and other functions. Dedicated buses make it easier to coordinate large groups around wedding schedules and multiple ceremonies."
},
{
name: "Local Event Bus Rental Pune",
description: "Local Event Bus Rental Pune is useful for transporting guests and participants to exhibitions, cultural programs, private functions, celebrations, and public events. Group transportation can be arranged around venue timings, pickup points, event duration, and return requirements."
},
{
name: "Local Corporate Bus Hire Pune",
description: "Local Corporate Bus Hire Pune supports employee travel, office meetings, business events, team outings, training programs, and company functions. A dedicated bus can connect employees between offices, hotels, event venues, and other business locations according to a planned schedule."
},
{
name: "Local Picnic Bus Pune",
description: "Local Picnic Bus Pune is suitable for families, friends, schools, companies, and community groups planning short recreational outings. The bus can accommodate the group and provide convenient transportation between the selected pickup point, picnic destination, and return location."
},
{
name: "Local School Trip Bus Pune",
description: "Local School Trip Bus Pune provides organized transportation for educational visits, museum tours, recreational activities, cultural programs, and local excursions. Schools can plan suitable bus capacity and routes according to student groups, teachers, destinations, and trip schedules."
},
{
name: "Affordable Local Bus Rental Pune",
description: "Affordable Local Bus Rental Pune offers a practical way to manage group transportation costs for city travel and short trips. Choosing a vehicle according to the actual passenger count and planning an efficient route can help maintain a balance between comfort and budget."
},
{
name: "Local Bus Near Me Pune",
description: "Local Bus Near Me Pune is useful for customers searching for convenient group transportation close to their pickup location. Ruturaj Enterprises can coordinate local bus requirements around suitable pickup points, destinations, passenger strength, and planned travel timings."
},
{
name: "Pune Local Transportation Bus",
description: "Pune Local Transportation Bus services can be arranged for regular or occasional group movement across different parts of the city. They are suitable for employee travel, family functions, sightseeing, educational trips, events, and other requirements involving multiple passengers."
},
{
name: "Local Tourist Bus Pune",
description: "Local Tourist Bus Pune is designed for visitors and groups exploring Pune's historical, religious, cultural, and recreational destinations. A dedicated bus allows tourists to follow a planned itinerary with convenient movement between multiple attractions throughout the day."
},
{
name: "Local Bus Rental Service Pune",
description: "Local Bus Rental Service Pune provides flexible group transportation for sightseeing, family trips, weddings, school outings, corporate programs, picnics, and events. Vehicle selection and travel planning can be coordinated according to passenger capacity, route, duration, and local destination requirements."
}
],
tableData: [
["Local Bus Rental Pune", "Local Bus Hire Pune"],
["Local Bus Booking Pune", "Bus on Rent for Local Travel Pune"],
["Local AC Bus Rental Pune", "Local Luxury Bus Hire Pune"],
["Local Bus Service Pune", "City Bus Rental Pune"],
["Pune City Tour Bus Rental", "Local Sightseeing Bus Pune"],
["Local Group Travel Bus Pune", "Local Family Trip Bus Pune"],
["Local Wedding Bus Hire Pune", "Local Event Bus Rental Pune"],
["Local Corporate Bus Hire Pune", "Local Picnic Bus Pune"],
["Local School Trip Bus Pune", "Affordable Local Bus Rental Pune"],
["Local Bus Near Me Pune", "Pune Local Transportation Bus"],
["Local Tourist Bus Pune", "Local Bus Rental Service Pune"]
],
whychoose: [
{
WhyChooseheading: "Convenient Citywide Group Travel",
WhyChoosedescription: "Moving a large group around Pune becomes easier when everyone can travel in one dedicated vehicle. Local bus arrangements can be planned around common pickup points, multiple destinations, and the group's preferred schedule."
},
{
WhyChooseheading: "Flexible Local Itineraries",
WhyChoosedescription: "City journeys may include several stops during the same day, particularly for sightseeing, family functions, and events. The transportation plan can be structured around the destinations and timing requirements instead of depending on separate vehicles."
},
{
WhyChooseheading: "Options for Different Group Sizes",
WhyChoosedescription: "Every local trip has a different passenger requirement, from small family groups to larger school or corporate teams. Choosing a bus according to group size helps provide suitable seating capacity without unnecessarily arranging multiple vehicles."
},
{
WhyChooseheading: "Comfortable AC Travel",
WhyChoosedescription: "For longer city tours and full-day programs, a comfortable travel environment can make the journey more pleasant. AC bus options are suitable for sightseeing groups, families, corporate teams, wedding guests, and tourists."
},
{
WhyChooseheading: "Useful for Weddings and Events",
WhyChoosedescription: "Wedding functions and events often involve transportation between several locations at different times. A dedicated local bus can help move guests together between homes, hotels, halls, venues, and other scheduled locations."
},
{
WhyChooseheading: "Suitable for Schools and Groups",
WhyChoosedescription: "Educational excursions, school trips, family outings, and community programs require coordinated group transportation. Local bus hire provides a straightforward way to move students, teachers, families, or other participants together."
},
{
WhyChooseheading: "Planned Pickup and Drop Points",
WhyChoosedescription: "Multiple pickup locations can be important when passengers are spread across different neighborhoods. Local transportation can be organized around practical collection points before the group proceeds to the planned destination."
},
{
WhyChooseheading: "Practical Choice for Pune Tours",
WhyChoosedescription: "A dedicated bus is useful when an itinerary covers several attractions or activities in Pune during one journey. Group travel becomes easier to coordinate when transportation, sightseeing stops, event schedules, and return travel are planned together."
}
]
};














const faqData = [
{
question: "What is local bus hire in Pune?",
answer: "Local bus hire in Pune is a convenient transportation option for groups that need a private bus for city travel, events, functions, sightseeing, school programs, corporate activities, and family gatherings. Ruturaj Enterprises can arrange a suitable vehicle based on the group size, route, schedule, and purpose of travel."
},
{
question: "What types of trips can be arranged with a local bus in Pune?",
answer: "A hired bus can be used for local sightseeing, school trips, corporate events, weddings, family functions, picnics, religious programs, airport transfers, and group transportation within Pune. The travel schedule can be planned according to the specific requirements of the group."
},
{
question: "Can I hire a bus for a one-day local trip in Pune?",
answer: "One-day local bus rental is suitable for groups planning sightseeing, picnics, events, educational visits, or family outings. Ruturaj Enterprises can help arrange transportation around your preferred pickup time, destinations, number of passengers, and return schedule."
},
{
question: "What bus seating capacities are available for local hire in Pune?",
answer: "The appropriate seating capacity depends on the number of people traveling together. Ruturaj Enterprises can help select a suitable bus for small groups as well as larger parties, taking passenger count, luggage, route, and the nature of the local trip into consideration."
},
{
question: "Can I hire a local bus in Pune for a wedding function?",
answer: "Wedding families can arrange a local bus to transport relatives and guests between pickup points, hotels, marriage halls, venues, and other locations. A dedicated bus helps keep guests together and makes transportation easier to coordinate during different wedding functions."
},
{
question: "Is local bus hire suitable for school and college groups?",
answer: "Schools and colleges can use hired buses for educational visits, picnics, sports events, cultural programs, and group excursions. Selecting a vehicle according to the number of students and accompanying staff can make the transportation plan more organized."
},
{
question: "Can corporate companies hire a local bus in Pune?",
answer: "Corporate organizations can hire buses for employee transportation, office events, conferences, team outings, training programs, and company functions. A dedicated vehicle allows employees to travel together while following planned pickup and drop-off timings."
},
{
question: "Can a local bus be hired for Pune sightseeing?",
answer: "Groups can hire a bus for sightseeing around Pune and nearby attractions according to their preferred itinerary. The same vehicle can be used for multiple stops, making it convenient for families, school groups, visitors, and organizations traveling together."
},
{
question: "How early should I book a local bus in Pune?",
answer: "Advance booking is recommended when transportation is required during weekends, holidays, wedding seasons, school vacations, or major events. Sharing the travel date, passenger count, pickup location, destination, and timing in advance helps Ruturaj Enterprises plan a suitable vehicle."
},
{
question: "Why choose Ruturaj Enterprises for local bus hire in Pune?",
answer: "Ruturaj Enterprises offers private bus rental solutions for different group transportation needs within Pune. From family functions and picnics to corporate events and educational trips, the vehicle can be selected according to passenger capacity, route, timing, and the specific requirements of the journey."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Sameer Pawar",
feedback:
"We hired a local bus from Ruturaj Enterprises for a family function in Pune. Having everyone travel together made the transportation much easier to manage, especially when coordinating several pickup points. The arrangement worked well for our group and helped us stay on schedule.",
rating: 5
},
{
id: 2,
name: "Miss. Ayesha Khan",
feedback:
"Our college group needed a bus for a local outing in Pune, and Ruturaj Enterprises helped us arrange suitable transportation. The group could travel together instead of using separate vehicles, which made the day more organized and convenient from the beginning to the return journey.",
rating: 5
}
];

































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Local Bus Hire In Pune",
  "image": "https://ruturajenterprises.com/assets/images/local-bus-hire-in-pune.webp",
  "description":
    "Local Bus Hire In Pune for city travel, sightseeing, family outings, weddings, corporate events, school trips, group transportation, and local functions. Ruturaj Enterprises offers comfortable AC, non-AC, and luxury buses in multiple seating capacities for convenient travel within Pune and nearby areas, with experienced drivers, flexible rental durations, planned pickup and drop arrangements, and reliable service for one-day or hourly requirements.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/local-bus-hire-in-pune"
  }
};






    return (
        <div>

<Helmet>
  <title>
    Local Bus Hire In Pune | Local Bus Rental Pune | +91 9763381382
  </title>

  <meta
    name="description"
    content="Local Bus Hire In Pune for city travel, sightseeing, family trips, weddings, corporate events, school tours and group transportation. Choose comfortable AC, non-AC and luxury buses with flexible rental options."
  />

  <meta
    name="keywords"
    content="Local Bus Rental Pune, Local Bus Hire Pune, Local Bus Booking Pune, Bus on Rent for Local Travel Pune, Local AC Bus Rental Pune, Local Luxury Bus Hire Pune, Local Bus Service Pune, City Bus Rental Pune, Pune City Tour Bus Rental, Local Sightseeing Bus Pune, Local Group Travel Bus Pune, Local Family Trip Bus Pune, Local Wedding Bus Hire Pune, Local Event Bus Rental Pune, Local Corporate Bus Hire Pune, Local Bus on Rent Pune, Bus Rental for Local Travel Pune, Bus Hire for Local Travel Pune, Pune Local Bus Booking Service, Pune City Bus Hire, Pune City Bus Rental, Pune Local Sightseeing Bus Rental, Pune Local Tour Bus Hire, Pune Local Tour Bus Rental, Pune Darshan Bus Rental, Pune Darshan Bus Hire, Pune One Day Bus Rental, Pune One Day Local Bus Hire, Local Bus Rental Near Me Pune, Affordable Local Bus Rental Pune, AC Local Bus Hire Pune, AC Local Bus Rental Pune, Non AC Local Bus Rental Pune, Non AC Local Bus Hire Pune, Luxury Local Bus Rental Pune, Luxury Local Bus Hire Pune, Local Mini Bus Rental Pune, Local Mini Bus Hire Pune, Local Bus for Family Trip Pune, Local Bus for Group Travel Pune, Local Bus for Wedding Pune, Local Bus for Marriage Pune, Local Bus for Corporate Events Pune, Local Bus for Corporate Travel Pune, Local Bus for School Trips Pune, Local Bus for College Trips Pune, Local Bus for Picnic Pune, Local Bus for Events Pune, Local Bus for Religious Tours Pune, Local Bus for Temple Visits Pune, Local Bus for Airport Transfer Pune, Local Bus for Hotel Transfer Pune, Local Bus for Function Pune, Local Bus for Party Pune, 20 Seater Local Bus Pune, 32 Seater Local Bus Pune, 35 Seater Local Bus Pune, 45 Seater Local Bus Pune, 50 Seater Local Bus Pune, Local Bus Rental for Full Day Pune, Local Bus Rental for Half Day Pune, Hourly Local Bus Rental Pune, Pune Local Group Transportation, Pune City Group Bus Service, Pune Local Corporate Transportation, Pune Local Wedding Transportation, Ruturaj Enterprises Local Bus Service Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/33.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Localbushireinpune;